import {
  SET_FOCUS_EVENT
} from './constants'

export function setFocusEvent (data) {
  return {
    type: SET_FOCUS_EVENT,
    data
  }
}

export function reducer (state, action) {
  switch (action.type) {
    case SET_FOCUS_EVENT:
      return {
        ...state,
        focusEvent: action.data,
        focusDevice: null // Clear focusDevice when focusing an event
      }

    default:
      return state
  }
}
